import React, { Component } from "react"
import "./Index.scss"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"
import { observer } from 'mobx-react'
import DataChart from './containers/DataChart'
import statisticsIcon from "app/styles/images/sp/statistics-selected.svg"
import Store from "app/stores/preview/bill"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    const { store } = this
    return (
      <div className="bill-page bill">
        <h2 className="page-title"><img alt="" src={statisticsIcon} />账单</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={store} />
        </div>
        <div style={{ marginTop: 60 }}>
          <DataChart store={this.store} />
        </div>

        <DataTable store={store} />
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/bill/index.js